import Footer from '~/components/layout/Footer'
import { Button } from '~/components/ui/Button'
import { Text } from '~/components/ui/Text'
import { usePageTitle } from '~/hooks/usePageTitle'

export default function GuestError() {
  usePageTitle('Guest Error')

  return (
    <div className='bg-dark-20'>
      <div className='flex flex-col text-white gap-y-4 min-h-screen'>
        <div className='flex flex-col items-center justify-center gap-y-4 h-[calc(100vh-140px)]'>
          <Text as='h1' size='xl' weight='bold' variant='light'>
            There was an error initializing your guest account
          </Text>

          <div className='flex justify-center'>
            <Button
              variant='danger'
              onClick={() => {
                window.location.reload()
              }}>
              Try Again
            </Button>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}
